module.exports = __webpack_public_path__ + "img/jeonpo_gallery0.7ac2d04f.jpg";